export default __webpack_public_path__ + "static/media/01_Kom_GENO.9754205e.jpg";